<template>
  <div class="minHeight">
      <micro-class-screen v-bind:isQuestionBank="true" v-bind:fromIndexRes="fromIndexResouresData" @goMaterialId="goMaterialId"></micro-class-screen>
      <div id="content" class="questionBank">
          <directory-tree></directory-tree>
          <question-bank-content></question-bank-content>
      </div>
  </div>
</template>

<script>
import MicroClassScreen from '../MicroClassScreen/questionBankScreen.vue'
import DirectoryTree from '../DirectoryTree/questionBankDirectoryTree.vue'
import QuestionBankContent from '../questionBankContent/questionBankContent.vue'
export default {
    name:'questionBank',
    props:{
      fromIndexResouresData:{
        type:Object,
        default:{'isFromIndexSyn':null,'subjectId':80,'routerMicroName':null}
      }
    },
    data(){
        return{

        }
    },
    mounted(){
		this.$nextTick(()=>{
		  $(document).scrollTop(0);
		})
    },
    methods:{
        goMaterialId(msg){
        }
    },
  components: { MicroClassScreen ,DirectoryTree,QuestionBankContent},

}
</script>

<style>
    .questionBank{
        display: flex;
        flex-direction: row;
        margin-top: 26px!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/questionBank/questionBank.vue